import React from 'react';

import ItemsPreview from '../../common/ItemsPreview/ItemsPreview';

export default function OrderPreview(props) {
    const products = (props.items || []).filter(item => item.type === 'product');
    const cards = (props.items || []).filter(item => item.type === 'card');

    return <ItemsPreview
        products={products}
        cards={cards}
        emptyText="Comanda nu are produse"
        getProductQuantity={(product) => product.quantity}
        getCardQuantity={(card) => card.quantity}
        productImageBucket={process.env.REACT_APP_IMAGE_STORAGE}
        cardImageBucket={process.env.REACT_APP_CARD_IMAGE_BUCKET}
        productImagePrefix="thumb_"
        productImageSuffix=".webp"
    />
}
